/**
 * Applications permitted to use legacy conversion metric link updating.
 * Matched exactly against internalChromeConfig.applicationName.
 */
const LEGACY_CONVERSION_METRICS_ALLOWLIST: ReadonlySet<string> = new Set([
  'ADSPNextCampaignHubWebsite',
  'ADSPNextKapowWebsite',
  'ADSPNextRodeoWebsite',
  'AdsDeeplinkWebsiteNawsService',
  'AdvertiserSupportContentService',
  'AdvertiserUserManagementService',
  'AdvertisingBillingWebAppService',
  'Avicenna',
  'BigTopBillingHistoryService',
  'D16GBazaarWebsiteService',
  'D16GBillingHubWebService',
  'D16GChangeHistoryConsoleService',
  'D16GEventManagerWebsiteContentService',
  'D16GFrequencyGroupWebsiteContentService',
  'D16GGssDashboardWeb',
  'D16GKapow',
  'D16GKapowWebsiteContent',
  'D16GMinivanService',
  'D16GOnyxWebsite',
  'D16GOnyxiaWebsiteContent',
  'D16GRodeoBulkWebsiteServiceNAWS',
  'D16GRodeoWebsite',
  'D16GRodeoWebsiteContent',
  'D16GSupHubConsoleService',
  'DACXCalciferHorizonteService',
  'KrangBackstageWebService',
  'MaaSAdvertisingConsoleWebsiteService',
  'Nuggle',
  'ProviderSearchToolService',
  'StudySetup',
]);

export const isAppAllowlisted = (appName: string): boolean =>
  LEGACY_CONVERSION_METRICS_ALLOWLIST.has(appName);
